module.exports = __webpack_public_path__ + "img/iepsis.4335b630.png";